import BlogPostMetadata from "./BlogPostMetadata";
export default BlogPostMetadata;
